'use client';
import React from 'react';
import { Props } from './CMEModal';
import dynamic from 'next/dynamic';
import { useCMEContext } from '../../../context/CMEContext';

const CMEModal = dynamic(() => import('./CMEModal'), { ssr: false });

/**
 * Wrapper component for the CMEModal to load dynamically.
 * @param props - Props for the CMEModal component.
 */
const CMEModalWrapper: React.FC<Props> = (props) => {
  const { cmeModal: modalProps } = useCMEContext();

  if (!modalProps.isVisible) return null;

  return <CMEModal {...props} />;
};

export default CMEModalWrapper;
